import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';

import { checkForErrors } from '../../utils';
import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';
import {
  ApiCredentialsData,
  loadApiCredentialsData,
} from './load-api-credentials';

/** Updates an API key's friendly name + description, then re-fetches. */
export const updateApiCredential = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<(ApiCredentialsData & { cb?: () => void }) | void> => {
  if (event.type !== 'updateApiCredential') {
    return;
  }

  const projectId = ctx.project?.id;
  const customerId = ctx.project?.projectProStudioSetting?.customerId;

  if (!projectId || !customerId) {
    throwErrorWithId('Project ID and Customer ID are required');
    return;
  }

  const { id, pypeId, name, description, env, cb } = event.payload;

  const putMutation = {
    live: urqlGql.putPypeKeyLive,
    sandbox: urqlGql.putPypeKeySandbox,
  }[env];

  const response = await putMutation({
    projectId,
    customerId,
    id,
    pypeId,
    apiKeyUpdateInput: { friendlyName: name, description },
  });
  checkForErrors(response);

  const data = await loadApiCredentialsData(ctx);

  return { ...data, cb };
};
